import React from "react";
import { toast } from "react-toastify";

function ReportLink({
  title,
  url,
  isFavorite,
  toggleFavorite,
  inFavoritesSection,
  dragHandle,
  ...rest
}) {
  return (
    <div {...rest}>
      <span className="h5 clearfix">
        <div className="float-start">{title}</div>
        <div className="float-end">
          <i
            className="fas fa-arrow-circle-right fa-2x me-3"
            onClick={() => {
              if (url.includes("reportbase")) {
                toast.info(
                  "In the SAFY Portal Live site this would have taken you to the Foster Parent Reports Portal"
                );
              } else {
                window.open(url, title);
              }
            }}
          ></i>
          {/* <i
            className={
              isFavorite ? "fas fa-star align-top" : "far fa-star align-top"
            }
            title={isFavorite ? "Remove Favorite" : "Add Favorite"}
            onMouseDown={() => {
              toggleFavorite(title);
            }}
          ></i>
          {isFavorite && inFavoritesSection ? (
            <span className="ms-2 align-top">{dragHandle}</span>
          ) : null} */}
        </div>
      </span>
    </div>
  );
}

export default ReportLink;
